/* Assortion owns the cart when enabled; Electro remains the fallback. */
(() => {
  let timer, running = false, pending = false, revision = 0;
  const root = () => window.Shopify?.routes?.root || '/';
  const renderCount = (count) => {
    const target = document.getElementById('headerCartStatus');
    if (!target || !Number.isInteger(count)) return;
    const number = target.querySelector('.cart-count-number');
    const badge = target.querySelector('.header__cart-count');
    const label = target.querySelector('[data-tc-cart-count-label]');
    if (number) number.textContent = String(count);
    if (badge) {
      [...badge.classList].filter((name) => name.startsWith('header-cart-count-')).forEach((name) => badge.classList.remove(name));
      badge.classList.add(`header-cart-count-${count}`);
      badge.classList.toggle('opacity-0', count === 0); badge.classList.toggle('hidden-xs', count === 0);
    }
    if (label) label.textContent = (count === 1 ? label.dataset.one : label.dataset.other).replace('[count]', count);
  };
  const refreshCount = async () => {
    if (running) { pending = true; return; }
    running = true;
    const requested = revision;
    try {
      const response = await fetch(`${root()}cart.js`, { cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (requested === revision) renderCount(cart.item_count);
    } catch (_) { /* Keep the last confirmed count if offline. */ }
    finally { running = false; if (pending) { pending = false; schedule(); } }
  };
  const schedule = () => { revision++; clearTimeout(timer); timer = setTimeout(refreshCount, 150); };
  ['cart:updated', 'cart:update'].forEach((name) => document.addEventListener(name, schedule));
  window.addEventListener('pageshow', (e) => { if (e.persisted) schedule(); });
  window.TcCart = {
    refreshCount: schedule,
    async open(trigger) {
      const app = window.Assortion?.cart;
      if (app?.id === 'assortion') {
        // Do not open Electro behind the app drawer.
        window.shtCartDrawer?.closeDrawer();
        await app.open();
      } else if (window.shtCartDrawer) {
        window.shtCartDrawer.openDrawer(trigger);
      } else {
        window.location.assign(`${root()}cart`);
      }
    }
  };
})();
